export class ListComplianceResourcesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resources",
            "baseName": "resources",
            "type": "Array<ResourceComplianceRow>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "failingGroupBreakdowns",
            "baseName": "failingGroupBreakdowns",
            "type": "Array<GroupBreakdown>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListComplianceResourcesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
